import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllProgramTypes,
  onCreateProgramType,
  onDeleteProgramType,
  onGetProgramType,
  onUpdateProgramType,
} from '../../../app/modules/system-definitions/components/program-types/core/_requests'
import {onGetDegrees} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface ProgramTypeState {
  programTypes: any
  programType: any
  degrees: any
  isLoading: boolean
}
const initialState = {
  programTypes: [],
  programType: null,
  degrees: [],
  isLoading: true,
} as ProgramTypeState

export const fetchDegrees = createAsyncThunk('programType/fetchDegrees', async () => {
  const data: any = await onGetDegrees()

  return data.data.result.items
})

export const fetchProgramTypes = createAsyncThunk(
  'programType/fetchProgramTypes',
  async (param: any) => {
    const data: any = await onGetPagedAllProgramTypes(param)
    return data.data.result
  }
)

export const fetchProgramType = createAsyncThunk(
  'programType/fetchProgramType',
  async (param: any) => {
    const data: any = await onGetProgramType(param)
    return data.data.result
  }
)

export const updateProgramType = createAsyncThunk(
  'programType/updateProgramType',
  async (param: any) => {
    const data: any = await onUpdateProgramType(param)
    return data.data
  }
)

export const createProgramType = createAsyncThunk(
  'programType/createProgramType',
  async (param: any) => {
    const data: any = await onCreateProgramType(param)
    return data.data
  }
)

export const deleteProgramType = createAsyncThunk(
  'programType/deleteProgramType',
  async (param: any) => {
    const data: any = await onDeleteProgramType(param)
    return data.data
  }
)

const programTypeSlice = createSlice({
  name: 'programType',
  initialState,
  reducers: {
    clearProgramTypes: (state) => {
      state.programTypes = []
    },
    clearProgramType: (state) => {
      state.programType = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProgramTypes.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchProgramTypes.fulfilled, (state: any, action) => {
      state.programTypes = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchProgramTypes.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchProgramType.fulfilled, (state: any, action) => {
      state.programType = action.payload
    })
    builder.addCase(fetchDegrees.fulfilled, (state: any, action) => {
      state.degrees = action.payload
    })
  },
})

export const {clearProgramTypes, clearProgramType, activateLoading} = programTypeSlice.actions

export default programTypeSlice.reducer
